import {Helmet} from 'react-helmet-async';
import {Link} from 'react-router-dom';
import React from "react";
// import {useTranslation} from 'react-i18next';

const Home = () => {
    // const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Communitism - HeriScope | Home</title>
                <meta name="description"
                      content="Learn more about the Communitism Project and our community initiatives."/>
                <meta property="og:title" content="Communitism | Home" key="ogtitle"/>
                <meta property="og:description"
                      content="Discover more about the Communitism Project, our mission, and how to get involved."
                      key="ogdesc"/>
                <meta property="og:url" content="https://heriscope.communitism.space/about"/>
                <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>

            {/* Icon Section */}
            <div className='about-page-container'>
                <div className='row justify-content-center'>

                    <div className="content-area-about">
                        <div className="content-area-flexible">
                            <p>
                                <Link to='/spaces'>
                                    <img
                                        width='300'
                                        height='300'
                                        src='/img/communitism_logo_transparent_black.png'
                                        className='img-fluid brand-logo-about'
                                        alt='logo'
                                    />
                                </Link></p>

                            <h4>Επικοινωνία</h4>
                            <p>heriscope@communitism.space</p>

                            <h6>Για ό,τι θες να μας πεις:</h6>
                            <p>hello@communitism.space</p>

                            <h4>Μείνε σε επαφή!</h4>

                            <h6>Medium</h6>
                            <p>medium.com/@communitism</p>

                            <h6>Facebook</h6>
                            <p>facebook.com/communitism</p>

                            <h6>Instagram</h6>
                            <p>instagram.com/communitism</p>
                            <h4>Μη χάσεις τα νέα μας!</h4>

                            <p>Εγγράψου στο newsletter μας</p>
                            <h5>Θέλεις να συμμετέχεις; </h5>

                            <p>Μας αρέσει πολύ να
                                γνωρίζουμε νέα
                                πρόσωπα και ιδέες!</p>
                            <p>Συμπλήρωσε το
                                <a href="https://communitism.space/join-us/" target="_blank"
                                   rel="noopener noreferrer"> ερωτηματολόγιό </a> μας
                                για ανταλλαγή χώρων,
                                residencies,
                                πρακτική άσκηση και
                                προτάσεις
                                project.
                            </p>

                            <h5>Έλα μαζί μας!</h5>

                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default Home;
